import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/modal-blue-bg.mp4';
import NewApproachVideo from '../../video/new-approach.mp4';
import MagentaLine from '../elements/MagentaLine';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      delayChildren: 2.6,
      staggerChildren: 0.4,
    },
  },
};

const item = {
  hidden: { opacity: 0, x: -100 },
  show: { opacity: 1, x: 0, transition: { duration: 0.8 } },
};
export default function NewApproach() {
  return (
    <div id="new-approach" className="bh-tech-subpage">
      <img src={Bg} alt="" className="modal-full-bg" />
      <motion.video
        src={VideoBg}
        className="modal-full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="100px" left="19px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '28px',
              left: '18px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            New Approach
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '72px',
              left: '18px',
              letterSpacing: '0.95px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            The world's first hearing aid <strong>with an on-board DNN</strong>
          </motion.div>
        </div>
      </header>

      <motion.div
        id="animation-wrapper"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.3 }}
      >
        <motion.ul variants={container} initial="hidden" animate="show">
          <motion.li variants={item}>
            Engineered to meet the space and power requirements in a modern
            hearing aid
          </motion.li>
          <motion.li variants={item}>
            Trained with 12 million real-life sound scenes
          </motion.li>
          <motion.li variants={item}>
            Learned from sounds of the world the way the brain learns
          </motion.li>
          <motion.li variants={item}>
            Seamlessly handles virtually all sound scenes with unparalleled
            precision and clarity to provide the brain with better contrast and
            balance
          </motion.li>
        </motion.ul>
        <video
          width="612"
          height="auto"
          id="new-approach-video"
          autoPlay
          onClick={function (evt) {
            const video = evt.target;
            video.setAttribute('controls', 'controls');
          }}
        >
          <source src={NewApproachVideo} type="video/mp4" />
        </video>
      </motion.div>
    </div>
  );
}
